<template>
  <div class="layout-common">
    <!-- <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper> -->
    <div class="register">
      <Row :gutter="10" class="top">
        <Col span="24">
          <div class="title">
            全国药品交易会 展商报名/PHARMCHINA - Booth Application
          </div>
        </Col>
        <!-- <Col span="12" class="f-tar">
        <Button shape="circle" style="border-color:#d00300;color:#d00300;">中文</Button>
        <Button shape="circle" style="margin-left:10px" @click="$router.push(`/ex-register-en/register`)">English</Button>
        </Col> -->
      </Row>
      <registerForm ref="registerForm"></registerForm>
      <registerAddr ref="registerAddr"></registerAddr>

      <div class="tipInfo">
        <div class="info">
          <div class="info-title">注册费/Registration Fee</div>
          <p>1.会刊费、展商胸卡（含税）：580元</p>
          <p>
            2.立春小程序-企业专属店铺（含税）：乙方可在立春小程序线上平台开通企业账号，享有店铺搭建、产品展示、询盘管理功能权限。920元
          </p>
        </div>
        <div class="tip">最终展位费=展位费+注册费</div>
      </div>
      <div class="remark">
        <span>备注/Notes：</span
        ><Input
          v-model="remark"
          type="textarea"
          :rows="4"
          :maxlength="200"
          placeholder="请简要输入您对展位的要求"
        />
      </div>

      <div
        class="basic register-entrance"
        style="margin-top: 80px"
        v-if="sectionLists.length > 0"
      >
        <div class="basic-header">
          <p>- 活动报名 -</p>
        </div>

        <div class="choice">
          <Row :gutter="40">
            <Col span="24">
              <div class="select-box group1">
                <div class="select-content">
                  <div
                    class="form-item width-95"
                    v-for="(section, index) in sectionLists"
                  >
                    <Form
                      :label-width="100"
                      :ref="'formValidate' + index"
                      :model="section"
                      :rules="rulesValidate"
                    >
                      <Row :gutter="16">
                        <Col span="8">
                          <FormItem label="" class="width-24" prop="title">
                            <Checkbox v-model="section.isCheck"></Checkbox
                            ><span
                              style="color: #d9001b; cursor: pointer"
                              @click="checkNameClick(section)"
                              >{{ section.name }}</span
                            >
                          </FormItem>
                        </Col>
                        <Col span="8" v-if="section.isCheck">
                          <FormItem
                            label="联系人"
                            class="width-24"
                            prop="linkName"
                          >
                            <Input
                              v-model="section.linkName"
                              placeholder="请输入联系人"
                            ></Input>
                          </FormItem>
                        </Col>
                        <Col span="8" v-if="section.isCheck">
                          <FormItem
                            label="联系电话"
                            class="width-24"
                            prop="linkTel"
                          >
                            <Input
                              v-model="section.linkTel"
                              placeholder="请输入联系电话"
                            ></Input>
                          </FormItem>
                        </Col>
                      </Row>

                      <Row :gutter="16" v-if="section.isCheck">
                        <Col span="8">
                          <FormItem label="邮箱" class="width-24" prop="">
                            <Input
                              v-model="section.linkEmail"
                              placeholder="请输入邮箱"
                            ></Input>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="部门" class="width-24" prop="">
                            <Input
                              v-model="section.linkDepartment"
                              placeholder="请输入部门"
                            ></Input>
                          </FormItem>
                        </Col>
                        <Col span="8">
                          <FormItem label="职务" class="width-24" prop="">
                            <Input
                              v-model="section.linkJobTitle"
                              placeholder="请输入职务"
                            ></Input>
                          </FormItem>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div class="f-tac submit-btn">
        <Button
          type="primary"
          size="large"
          @click="handleSubmit"
          :loading="loading"
        >
          确认以上信息，并提交展位申请/Confirm and submit</Button
        >
      </div>

      <div class="question">
        <p>常见问题</p>
        <Row :gutter="40" class="top">
          <Col span="12" v-for="(item, index) in questionArr">
            <div class="ques-item" @click="linkTo(item.url)">
              <img src="@/assets/img/Q.png" />
              <span>{{ item.title }}</span>
              <span v-if="item.click">请点击</span>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import { mapActions } from "vuex";
import registerForm from "./components/register-form.vue";
import registerAddr from "./components/register-addr.vue";
export default {
  name: "register",
  components: {
    registerForm,
    registerAddr,
    gSwiper,
  },
  props: {},
  data() {
    let that = this;
    const linkMobValid = (rule, value, callback) => {
      if (/^[1][0-9]{10}$/.test(value)) {
        callback();
      } else {
        callback("请输入正确的联系电话");
      }
    };
    return {
      remark: "",
      loading: false,
      arr: [{ id: 1, path: require("../../../assets/img/banner.jpg") }],
      questionArr: [
        {
          title: "标准展位图例及配置标准",
          url: "https://www.pharmchina.com.cn/page/qa/1664440923058212864",
        },
        {
          title: "如何申请到转角展位？",
          url: "https://www.pharmchina.com.cn/page/qa/1664441105611100160",
        },
        {
          title: "填写公司注册地址还是邮寄的地址？",
          url: "https://www.pharmchina.com.cn/page/qa/1664441136745418752",
        },
        {
          title: "特装、普装、普装改特装区别？",
          url: "https://www.pharmchina.com.cn/page/qa/1664441173659488256",
        },
        {
          title: "如何知道展位预定是否成功？",
          url: "https://www.pharmchina.com.cn/page/qa/1664441212771373056",
        },
        {
          title: "不同类别的展位有什么不同？",
          url: "https://www.pharmchina.com.cn/page/qa/1664441301334102016",
        },
        {
          title: "展位预订流程和分配原则？",
          url: "https://www.pharmchina.com.cn/page/qa/1664441335454765056",
        },
        // { title: '标准展台图例', url: 'https://www.pharmchina.com.cn/node/qa?id=2' },
        // { title: '标准展位图例及配置标准', url: 'https://www.pharmchina.com.cn/node/qa?id=13', click: true },
        {
          title: "如需预订会议室",
          url: "https://www.pharmchina.com.cn/node/conferenceBook",
          click: true,
        },
        {
          title: "如需预订大会赞助方案",
          url: "https://www.pharmchina.com.cn/node/sponsorship",
          click: true,
        },
        {
          title: "如需预订酒店",
          url: "http://jl.miceclouds.com/bookingquery.htm?id=1931",
          click: true,
        },
      ],

      sectionLists: [],

      rulesValidate: {
        linkName: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        linkTel: [{ required: true, validator: linkMobValid, trigger: "blur" }],
      },
    };
  },

  computed: {
    option() {
      return {
        exhibitionId: "57D57E6B-E417-4B44-90F7-A855C96886AD",
        pageSize: 99,
        pageIndex: 1,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "",
                  Value: "",
                },
              },
            ],
          },
        },
      };
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: "registerdModule/getApplyCompanyRoastCreate", // 新增展会接口
      PCActivityPage: "hostSetModule/PCActivityPage",
      PCActivityUpdateRegCount: "hostSetModule/PCActivityUpdateRegCount", //修改活动注册数量
    }),

    async activityWay() {
      let arr = [];
      this.sectionLists.forEach((item, index) => {
        let form = "formValidate" + index;
        this.$refs[form][0].validate((valid) => {
          if (valid) {
            arr.push(true);
          } else {
            arr.push(false);
          }
        });
      });
      let flag = arr.every((item) => {
        return item === true;
      });
      if (flag) {
        //全部为true,验证通过
        //验证通过
        // this.$Message.success("通过");
        return Promise.resolve({ valid: true });
      } else {
        // this.$Message.error("信息填写有误");
        return Promise.resolve({ valid: false });
      }
    },

    async handleSubmit() {
      // console.log( sessionStorage.getItem('exhibitionSelectId'),);
      // debugger
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerAddr.validHandle();
      this.loading = false;
      if (!res2.valid) return;

      let res3 = await this.activityWay();
      if (!res3.valid) return;
      let actList = [];
      let Ids = [];
      let actData = {};
      this.sectionLists.forEach((item, index) => {
        if (item.isCheck) {
          actData.pcActivityId = item.id;
          actData.applyCompanyId = "00000000-0000-0000-0000-000000000000";
          actData.exhibitionId = item.exhibitionId;
          actData.linkName = item.linkName;
          actData.linkTel = item.linkTel;
          actData.linkEmail = item.linkEmail;
          actData.linkDepartment = item.linkDepartment;
          actData.linkJobTitle = item.linkJobTitle;
          actList.push(actData);
          Ids.push(item.id);
          actData = {};
        }
      });
      console.log(actList);

      console.log("registerForm", res);
      console.log("registerAddr", res2);
      let opt = {
        newCompany: {
          ...res.form,
          isNeedUpdate: res2.isNeedUpdate,
          isNeedAngular: res2.isNeedAngular,
        },
        lists: [
          {
            // exhibitionId: "57D57E6B-E417-4B44-90F7-A855C96886AD",
            exhibitionId: sessionStorage.getItem("exhibitionSelectId"),
            ...res2.ApplyCompanyOrderNewDto,
            remark: this.remark,
          },
        ],
        activites: actList,
        reportType: "cn",
      };
      console.log("option", opt);
      let bool = await this.getApplyCompanyRoastCreate(opt);
      let count = await this.PCActivityUpdateRegCount({ activityIds: Ids });
      this.loading = false;
      console.log("getApplyCompanyRoastCreate", bool);
      if (bool && bool.successed) {
        let query =
          "company=" +
          encodeURI(res.form.companyName) +
          "&exname=" +
          encodeURI(res2.exhibition.name) +
          "&exstartTime=" +
          encodeURI(res2.exhibition.startTime) +
          "&exendTime=" +
          encodeURI(res2.exhibition.endTime) +
          "&excity=" +
          encodeURI(res2.exhibition.city) +
          "&exareaName=" +
          encodeURI(res2.ApplyCompanyOrderNewDto.areaName) +
          "&exareaType=" +
          encodeURI(res2.ApplyCompanyOrderNewDto.areaType) +
          "&exshowArea=" +
          encodeURI(res2.ApplyCompanyOrderNewDto.showArea);
        this.$router.push(`/ex-register/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "提交失败，请重新尝试！";
        if (bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }
    },
    handleSubmit1() {
      this.$router.push(`/ex-register/register-result`);
    },

    linkTo(url) {
      if (!url) return;
      if (url.indexOf("http") !== -1 || url.indexOf("https") !== -1) {
        window.open(url);
      } else {
        this.$router.push(url);
      }
    },

    async init() {
      let list = await this.PCActivityPage(this.option);
      if (list && list.items.length > 0) {
        list.items.map((e) => {
          e.isCheck = false;
          e.linkName = "";
          e.linkTel = "";
          e.linkEmail = "";
          e.linkDepartment = "";
          e.linkJobTitle = "";
        });
        this.sectionLists = list.items;
        console.log(this.sectionLists, "sectionLists0000000");
      }
    },

    checkNameClick(e) {
      console.log(e);
      if (e.type == "textArea") {
        const routeData = this.$router.resolve({
          path: "/ex-register/register-detail",
          query: { html: e.content },
        });

        window.open(routeData.href, " _blank");
      }
      if (e.type == "url") {
        window.open(e.url, "_blank");
      }
    },
  },
  created() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.$router.push(`/ex-register/register-mobile`);
    }
    document.title = "全国药品交易会参展报名/PHARMCHINA - Booth Application";
  },
};
</script>

<style lang="scss" scoped>
.basic {
  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #d00300 !important;
    }

    .ivu-radio-inner:after {
      background-color: #d00300;
    }

    .ivu-switch-checked {
      border-color: #d00300;
      background-color: #d00300;
    }

    .ivu-checkbox-checked .ivu-checkbox-inner {
      border-color: #d00300;
      background-color: #d00300;
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: #d00300;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-title {
    font-size: 18px;
    line-height: 48px;
    background-color: #f2f2f2;
    color: #333;
    margin-bottom: 30px;
    padding-left: 30px;

    span {
      font-size: 14px;
    }
  }
}

.choice {
  margin-bottom: 30px;
}

.choicebox {
  min-height: 686px;
  background-color: #fff;
  border: solid 1px #e5e5e5;
  position: relative;
  cursor: pointer;
  overflow: hidden;

  &.active {
    background-color: #fdf7f9;
    border: solid 1px #d00300;

    .select {
      opacity: 1;
    }

    .choicebox-content ::v-deep {
      .ivu-radio-group-item {
        &:nth-child(odd) {
          background-color: #f5eff1;
        }
      }
    }

    .choicebox-tool {
      background-color: #f5eff1;
    }
  }

  .select {
    position: absolute;
    opacity: 0;
    text-align: center;
    top: 0;
    right: 0;
    width: 84px;
    height: 32px;
    line-height: 32px;
    background-color: #d00300;
    border-radius: 0px 0px 0px 10px;
    border: solid 1px #d00300;
    font-size: 14px;
    color: #fff;
  }

  &-content {
    padding: 30px;

    .title {
      text-align: center;
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
    }

    .item {
      display: flex;
      align-items: center;
      flex: 1;

      &-box {
        width: 50%;
      }

      &-box2 {
        width: 50%;

        p {
          font-size: 14px;
          color: #333;
          font-weight: normal;
        }
      }
    }

    ::v-deep {
      .ivu-radio-group-item {
        width: 100%;
        display: flex;
        align-items: center;
        min-height: 74px;
        padding: 15px 10px 15px 20px;

        &:nth-child(odd) {
          background-color: #f7f7f7;
        }
      }
    }
  }

  &-tool {
    height: 73px;
    background-color: #f7f7f7;
    padding-left: 24px;
    border-top: solid 1px #e5e5e5;
    display: flex;
    align-items: center;
  }
}

.select-box {
  .select-content {
    padding: 30px 50px;
    border: solid 1px #e5e5e5;
    border-top: none;
  }
}

.layout-common {
  margin: 0 auto;
}

.register {
  max-width: 1200px;
  margin: 0 auto;

  .top {
    padding: 29px 0 40px;
  }

  .title {
    font-size: 30px;
    color: #333;
    font-weight: bold;
  }
}

.submit-btn {
  margin-top: 60px;
  text-align: center;

  button {
    padding: 0 46px;
    height: 48px;
    background-color: #d00300;
    font-size: 16px;
    border-color: #d00300;
    margin-bottom: 51px;
  }
}

.tipInfo {
  .info {
    color: #333;
    line-height: 1.8;
    margin-bottom: 28px;

    &-title {
      font-size: 16px;
      font-weight: 500;
    }

    p {
      font-size: 12px;
    }
  }

  .tip {
    font-size: 16px;
    line-height: 24px;
    color: #f00;
    margin-bottom: 30px;
  }
}

.remark {
  display: flex;
  align-items: top;

  span {
    width: 115px;
    font-size: 16px;
    color: #333;
    padding-top: 10px;
  }
}

.question {
  p {
    font-size: 18px;
    color: #333;
  }

  .ques-item {
    cursor: pointer;
    line-height: 46px;
    background-color: #f7f7f7;
    border-radius: 5px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    img {
      width: 18px;
      height: 18px;
      display: inline-block;
      margin-right: 12px;
    }
  }
}
</style>
